"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('phone-off', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M19.4438 21.5C19.017 20.4325 18.8747 19.7006 18.8747 19.7006L21.2315 14.9869C21.5266 14.3966 21.5116 13.6988 21.1913 13.1218L18.7448 8.71493C18.3922 8.07969 17.7228 7.68566 16.9962 7.68566L11.9236 7.68566C9.33993 7.68566 7.47453 10.0879 8.30063 12.5359C9.5121 16.1259 11.5052 21.1306 14.3465 25.5M26.6772 28.9115C27.9041 29.4332 28.7742 29.6001 28.7742 29.6001L33.4871 27.2436C34.0778 26.9483 34.7762 26.9636 35.3534 27.2845L39.7727 29.7415C40.4073 30.0943 40.8009 30.7634 40.8009 31.4895L40.8009 36.563C40.8009 39.1466 38.3973 41.0116 35.9493 40.1855C32.2021 38.9208 26.9142 36.8048 22.4161 33.7617",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M40 8L8 40",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;